/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, August 2022
 * @format
 * @flow
 */

import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Group, Rect, Transformer, Text as KonvaText } from 'react-konva';
import tranformerConfig from './tranformerConfig';

//Table description:- Table_10_Rect_5_5_135Deg
//Table_<seat capacity>_<table type>_<seat arrangement>_<angle>Deg
const Table_10_Rect_5_5_135Deg = props => {
  const {
    shapeProps,
    isSelected,
    onSelect,
    onChange,
    draggable,
    tableInfoColumn,
    keyName1,
    keyName2,
    keyName3,
  } = props;
  const { x, y, scaleX, scaleY, rotation, stroke, strokeWidth } = shapeProps;
  const shapeRef = useRef();
  const trRef = useRef();

  useEffect(() => {
    if (draggable && isSelected) {
      trRef.current.setNode(shapeRef.current);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  const onDragEnd = e => {
    onChange && onChange({
      ...shapeProps,
      x: e.target.x(),
      y: e.target.y(),
    });
  };

  const onTransformEnd = e => {
    //transformer is changing scale
    const node = shapeRef.current;
    const scaleX = node.scaleX();
    const scaleY = node.scaleY();
    node.scaleX(1);
    node.scaleY(1);
    onChange && onChange({
      ...shapeProps,
      x: node.x(),
      y: node.y(),
      scaleX: scaleX,
      scaleY: scaleY,
      rotation: node.rotation(),
    });
  };

  return (
    <>
      <Group
        onClick={onSelect}
        onTap={onSelect}
        ref={shapeRef}
        x={x}
        y={y}
        scaleX={scaleX}
        scaleY={scaleY}
        rotation={rotation}
        draggable={draggable}
        onDragEnd={onDragEnd}
        onTransformEnd={onTransformEnd}
      >
        <Group x={0} y={0} rotation={45}>
          <Rect x={10} y={0} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
          <Rect x={60} y={0} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
          <Rect x={110} y={0} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
          <Rect x={160} y={0} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
          <Rect x={210} y={0} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
          <Rect x={0} y={10} stroke={stroke} strokeWidth={strokeWidth} width={260} height={80} />
          <Rect x={10} y={90} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
          <Rect x={60} y={90} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
          <Rect x={110} y={90} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
          <Rect x={160} y={90} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
          <Rect x={210} y={90} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
        </Group>
        {tableInfoColumn && <KonvaText text={shapeProps[tableInfoColumn]} x={25} y={115} fill={stroke} fontSize={25} />}
        {keyName1 && <KonvaText text={shapeProps[keyName1]} x={-30} y={45} fill={'white'} fontSize={14} />}
        {keyName2 && <KonvaText text={shapeProps[keyName2]} x={90} y={190} fill={'white'} fontSize={14} />}
        {keyName3 && <KonvaText text={shapeProps[keyName3]} x={80} y={115} fill={'white'} fontSize={14} />}
      </Group>
      {draggable && isSelected && <Transformer ref={trRef} {...tranformerConfig} />}
    </>
  );
};

export default Table_10_Rect_5_5_135Deg;

Table_10_Rect_5_5_135Deg.propTypes = {
  shapeProps: PropTypes.object,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
  draggable: PropTypes.bool,
  tableInfoColumn: PropTypes.string,
};

Table_10_Rect_5_5_135Deg.defaultProps = {
  shapeProps: {},
  isSelected: false,
  onSelect: () => { },
  onChange: () => { },
  draggable: true,
};
